import { render, staticRenderFns } from "./ChapterIndicator.vue?vue&type=template&id=4d458fa2&scoped=true"
import script from "./ChapterIndicator.vue?vue&type=script&lang=ts"
export * from "./ChapterIndicator.vue?vue&type=script&lang=ts"
import style0 from "./ChapterIndicator.vue?vue&type=style&index=0&id=4d458fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d458fa2",
  null
  
)

export default component.exports